import { useClientApplicationQuery } from "@graphql/client-applications/ClientApplications.g";
import {
  ClientFragment,
  useUpdateClientMutation,
} from "@graphql/clients/clients.g";
import { useMemo } from "react";

import {
  ClientApplicationForm,
  ClientApplicationFormValues,
} from "@components/Forms";

type Props = {
  clientId: string;
  clientApplicationId: string;
  onUpdateClientSuccess?: (data: ClientFragment) => Promise<void> | void;
  withSubmitButton?: boolean;
  disabled?: boolean;
};

export const UpdateClientApplicationForm = ({
  clientId,
  clientApplicationId,
  onUpdateClientSuccess,
  withSubmitButton = true,
  disabled = false,
}: Props) => {
  const clientApplicationQuery = useClientApplicationQuery({
    clientId,
    clientApplicationId,
  });
  const updateClientMutation = useUpdateClientMutation();
  const updateClient = updateClientMutation.mutateAsync;

  const clientApplication =
    clientApplicationQuery.data?.clientApplication ?? undefined;

  const values = useMemo(() => {
    return {
      productName: clientApplication?.resource?.productName ?? "",
      productDomainName: clientApplication?.resource?.productDomainName ?? "",
      productDescription: clientApplication?.resource?.productDescription ?? "",
      vendorName: clientApplication?.resource?.vendorName ?? "",
      vendorDomainName: clientApplication?.resource?.vendorDomainName ?? "",
      vendorDescription: clientApplication?.resource?.vendorDescription ?? "",
      usedBy: clientApplication?.resourceGroupApplications?.stats?.totalEmployees?.toString() ?? "",
    };
  }, [clientApplication]);

  const onSubmit = async (values: ClientApplicationFormValues) => {
    const data = await updateClient({
      input: {
        id: clientId,
        ...values,
      },
    });

    const client = data?.updateClient?.client;

    if (!client) return;

    await onUpdateClientSuccess?.(client);
  };

  return (
    <ClientApplicationForm
      onSubmit={onSubmit}
      values={values}
      submitText="Update"
      withSubmitButton={withSubmitButton}
      disabled={disabled}
      clientId={clientId}
      category={clientApplication?.resource?.publicResource?.category}
    />
  );
};
